import { IconFileDots } from '@tabler/icons-react';

import { Box } from '@mui/material';

import { SwitchCompany } from '../../modules/components/companies/SwitchCompany';
import { PageContainer } from '../../modules/components/page/PageContainer';
import { PageTitle } from '../../modules/components/page/PageTitle';

import { TerminationSimulationTable } from './components/table/Table';

export type TerminationSimulationProps = {
  organizationId: string;
  companyId: string;
};

function TerminationSimulationPage({
  organizationId,
}: TerminationSimulationProps) {
  return (
    <PageContainer>
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="row"
        alignItems="center"
        gap={2}
      >
        <PageTitle
          dataTestId="termination-simulation-header"
          icon={IconFileDots}
          title="Simulação"
          subTitle="Rescisão"
        />

        <SwitchCompany />
      </Box>

      <TerminationSimulationTable organizationId={organizationId} />
    </PageContainer>
  );
}

export default TerminationSimulationPage;
